import {
    Box,
    Typography,
} from "@mui/material";
import {FC} from "react";
import {BackButton} from "../../buttons/BackButton";
import {RoutesPath} from "../../../enums/RoutesPath";

interface IMotorcycleHeader {
    title: string;
}

export const MotorcycleHeader: FC<IMotorcycleHeader> = ({title}) => (
    <Box sx={{display: "flex", alignItems: "center", marginBottom: 2}}>
        <BackButton fallbackUrl={RoutesPath.CATALOGUE}/>
        <Typography variant="h4" component="h1" sx={{fontWeight: "bold", marginLeft: 2}}>
            {title}
        </Typography>
    </Box>
);
